document.querySelectorAll('[data-gallery]').forEach(gallery => {
  const dialog = gallery.querySelector('dialog');
  if (!dialog) return;
  const photos = [...gallery.querySelectorAll('[data-full-image]')];
  let index = 0;
  const show = value => {
    index = (value + photos.length) % photos.length;
    const image = dialog.querySelector('[data-enlarged-image]');
    image.src = photos[index].dataset.fullImage;
    image.alt = photos[index].dataset.imageAlt;
    image.width = Number(photos[index].dataset.imageWidth);
    image.height = Number(photos[index].dataset.imageHeight);
    dialog.querySelector('[data-image-counter]').textContent = `${index + 1} / ${photos.length}`;
  };
  gallery.querySelectorAll('[data-open-image]').forEach(button => button.addEventListener('click', () => {
    show(Number(button.dataset.openImage)); dialog.showModal();
  }));
  dialog.querySelector('[data-image-prev]').addEventListener('click', () => show(index - 1));
  dialog.querySelector('[data-image-next]').addEventListener('click', () => show(index + 1));
  dialog.querySelector('[data-image-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('keydown', event => {
    if (event.key === 'ArrowLeft') { event.preventDefault(); show(index - 1); }
    if (event.key === 'ArrowRight') { event.preventDefault(); show(index + 1); }
  });
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
});

document.querySelectorAll("[data-variant-select]").forEach(select => select.addEventListener("change", () => { const url = new URL(location.href); url.searchParams.set("variant", select.value); location.assign(url); }));
document.querySelectorAll('[data-address-country]').forEach(country => {
  const province = country.form.querySelector('[data-address-province]');
  if (country.dataset.default) country.value = country.dataset.default;
  const update = () => {
    let values = []; try { values = JSON.parse(country.selectedOptions[0]?.dataset.provinces || '[]'); } catch { /* Shopify supplies country data. */ }
    province.replaceChildren(...values.map(([value,label]) => new Option(label,value)));
    province.closest('label').hidden = values.length === 0;
  };
  update(); if (province.dataset.default) province.value = province.dataset.default;
  country.addEventListener('change',update);
});
